import { GameProps } from "shared/games/types/GameConfiguration";
import { GameAnswerMixPuzzle } from "shared/games/types/GameAnswers";
import { GameQuestionMixPuzzle } from "shared/games/types/GameQuestions";
import { useAudioChangeController } from "../hooks/useAudioChangeController";
import useMixPuzzleState from "../state/useMixPuzzleState";
import Toolbar from "../organisms/Toolbar";
import grader from "../state/grader";
import MixPuzzleTemplate from "../templates/MixPuzzleTemplate";
import * as GameLayout from "ui/templates/Game/LayoutComponents";
import { State } from "../state/reducer";

type Props = GameProps<GameQuestionMixPuzzle, GameAnswerMixPuzzle> & {
  onAdminSubmit?: (state: State) => void;
};

function MixPuzzleGame({
  question,
  onLoaded,
  onSubmit,
  onAdminSubmit,
  mobileToolbarStyle,
  submitInProgress,
}: Props) {
  const [state, dispatch] = useMixPuzzleState({
    type: "game-screen",
    difficulty: question.difficulty,
    mixPuzzle: question.mixPuzzle,
    __loadAnswerAsMix: !!onAdminSubmit,
  });
  const onRequestSubmit = () => {
    const grade = grader(state);

    onSubmit({
      type: "mixpuzzle",
      correct: grade.correct,
      grade,
    });

    onAdminSubmit?.(state);
  };

  useAudioChangeController({
    state,
    onLoaded,
    initialPlayState: true,
  });

  return (
    <>
      <GameLayout.Toolbar mobileStyle={mobileToolbarStyle}>
        <Toolbar
          state={state}
          onRequestSubmit={onRequestSubmit}
          submitInProgress={submitInProgress}
          updatePlaybackState={(value) =>
            dispatch({ type: "updatePlaybackState", payload: value })
          }
        />
      </GameLayout.Toolbar>

      <MixPuzzleTemplate
        state={state}
        dispatch={dispatch}
        mobileToolbarStyle={mobileToolbarStyle}
      />
    </>
  );
}

export default MixPuzzleGame;
